export default __webpack_public_path__ + "static/media/filtergrey.28afd71a.svg";